<template>
	<div class="white-bg radius-8 mb-16">
		<div class="flex flex-align-center pt-24 pl-24">
			<div class="fz-18 font-bold">排期日历</div>
		</div>
		<div class="calendar">
			<div class="date">
				<ele-calendar
					:render-content="renderContent"
					:data="datedef"
					:prop="prop"
					@pick="pick"
					@date-change="dateChange"
					currentmonth
					@select="selectFun"
				></ele-calendar>
			</div>
			<div class="p-24">
				<div class="details" v-if="detail_list.length">
					<live-box
						ref="liveBox"
						v-for="(item, index) in detail_list"
						:detail_list="detail_list"
						:key="index"
						:ind="index"
						:detailObj="item"
					></live-box>
				</div>
				<Empty v-if="!detail_list.length">
					<template #desc>
						<p class="font-h6-regular yx-color-text-secondary">暂无直播</p>
					</template>
				</Empty>
			</div>
		</div>
	</div>
</template>

<script>
import eleCalendar from 'ele-calendar';
import 'ele-calendar/dist/vue-calendar.css';
import liveBox from './liveBox.vue';
import { calendarList, calendarDetail } from '@/api/home';
export default {
	components: {
		liveBox,
		eleCalendar,
	},
	name: 'calendar',
	data() {
		return {
			date_list: [],
			detail_list: [],
			datedef: [],
			prop: 'date', //对应日期字段名
		};
	},
	props: {
		id: {
			type: [String, Number],
			default: '',
		},
	},
	watch: {},
	methods: {
		async calendarList(value, authority_id) {
			const { getCurrentMonthFirst, getCurrentMonthLast, curStartTime, curEndTime } = this;
			const res = await calendarList({
				start_time: Math.trunc(curStartTime(getCurrentMonthFirst(value)) / 1000),
				end_time: Math.trunc(curEndTime(getCurrentMonthLast(value)) / 1000),
				authority_id: authority_id || this.id,
			});
			if (res.code !== 0) return;
			this.date_list = res.data.date_list;
			res.data.date_list.forEach((item, index) => {
				this.$set(this.datedef, index, { date: item, content: 'yes', class: 'a1', cid: null });
			});
		},
		async calendarDetail(value, authority_id) {
			const { curStartTime, curEndTime } = this;
			const res = await calendarDetail({
				start_time: Math.trunc(curStartTime(value) / 1000),
				end_time: Math.trunc(curEndTime(value) / 1000),
				authority_id: authority_id || this.id,
			});
			if (res.code !== 0) return;
			this.detail_list = res.data;
		},
		renderContent(h, parmas) {
			//设置lunarcalendar=true,parmas返回值包含农历
			const loop = data => {
				return data.defvalue.value ? (
					this.curStartTime(data.defdate) < this.curStartTime(new Date()) ? (
						<div style='position: relative;'>
							<div style='font-size: 14px;' class='DIN'>
								{data.defvalue.text}
							</div>
							<p style='font-size: 14px;position: absolute;left: 0;right: 0; top: 15px;color: #2475FF;opacity: 0.5;'>•</p>
						</div>
					) : (
						<div style='position: relative;'>
							<div style='font-size: 14px;' class='DIN'>
								{data.defvalue.text}
							</div>
							<p class='primary-color' style='font-size: 14px;position: absolute;left: 0;right: 0; top: 15px;'>
								•
							</p>
						</div>
					)
				) : (
					<div style='font-size: 14px;' class='DIN'>
						{data.defvalue.text}
					</div>
				);
			};
			return <div style='height:40px;'>{loop(parmas)}</div>;
		},
		pick(data, e) {
			let time = new Date(Date.parse(data)); //日期复制
			this.calendarDetail(time);
			this.calendarList(time);
		},
		dateChange(data) {
			this.calendarList(data);
		},
		selectFun(val, selectDom) {
			console.log('val', val);
			console.log('selectDom', selectDom);
		},
		//如：startUnix(2018-6-6) 返回的时间戳格式‘1528300799’
		startUnix($date) {
			return new Date(Date.parse($date.replace(/-/g, '/'))).getTime() / 1000;
		},
		endUnix($date) {
			return new Date().setTime(Date.parse($date.replace(/-/g, '/')) / 1000 + 24 * 60 * 60 - 1);
		},
		curStartTime(value) {
			let time = new Date(value.setHours(0, 0, 0, 0)).getTime();
			return time;
		},
		curEndTime(value) {
			let time = new Date(value.setHours(23, 59, 59, 999)).getTime();
			return time;
		},
		getCurrentMonthFirst(date) {
			date.setDate(1);
			return date;
		},
		getCurrentMonthLast(date) {
			var currentMonth = date.getMonth();
			var nextMonth = ++currentMonth;
			var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
			var oneDay = 1000 * 60 * 60 * 24;
			return new Date(nextMonthFirstDay - oneDay);
		},
	},
};
</script>

<style lang="less" scoped>
.date {
	padding: 0px 24px;
	/deep/ .el-picker-panel-calendar {
		border: none;
		box-shadow: none;
	}
	/deep/ .el-date-table-calendar td.current {
		background-color: @color-primary;
		color: #fff;
		border-radius: 20px;
		& > div {
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}
	/deep/ .el-date-table-calendar td {
		& > div {
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}
	/deep/ .el-date-table-calendar th {
		border-top: solid 1px #ebeef5;
		border-bottom: none;
	}
	/deep/ .el-date-picker-calendar__header-label {
		padding: 0px 0px;
		color: #333;
	}
	/deep/ .el-date-picker-calendar__header {
		margin: 8px 0px;
	}
}
/deep/ .empty {
	margin: 0px;
}
.details {
	max-height: 370px;
	//padding: 20px 0;
	border-radius: 4px;
	overflow: auto;
	&::-webkit-scrollbar {
		width: 6px;
	}
	&::-webkit-scrollbar-thumb {
		height: 26px;
		border-radius: 3px;
		background-color: #eeeeee;
	}
}
</style>
